export default "__VITE_ASSET__DVFUl$pX__"